import { ToggleControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { VayuBlocksDevice } from '@vayu-blocks/device-control';
import { useState } from '@wordpress/element';

export const VayuBlocksToggleControl = ({ checked, onChange, responsive = false, ...props }) => {
  
  const device = VayuBlocksDevice();
  const [firstDesktop, setFirstDesktop] = useState(false);
  const [firstTablet, setFirstTablet] = useState(false);

  const updateResponsiveValue = (newVal) => {
    const currentValues = checked?.value || {};
    const updatedAttributes = {
      ...currentValues,
      [device]: newVal,
    };

    const isFirstRun = !currentValues?.[device];
    const isTabletFirstRun = localStorage.getItem('firstTablet') || firstTablet;

    if (device === 'Desktop') {
      if (isFirstRun || firstDesktop) {
        updatedAttributes['Tablet'] = newVal;
        updatedAttributes['Mobile'] = newVal;
        localStorage.setItem('firstTablet', 'true');
        setFirstTablet(true);
        setFirstDesktop(true);
      }
    } else if (device === 'Tablet') {
      if (isTabletFirstRun) {
        updatedAttributes['Mobile'] = newVal;
        localStorage.removeItem('firstTablet');
        setFirstTablet(true);
        setFirstDesktop(false);
      }
    } else {
      setFirstTablet(false);
      setFirstDesktop(false);
    }

    onChange(checked?.key, updatedAttributes);
  };

  return (
    <ToggleControl
      className="vb-toggle-control"
      __nextHasNoMarginBottom={true}
      __next40pxDefaultSize={true}
      {...(typeof checked !== 'undefined' && {
        checked: responsive
          ? checked?.value?.[device] ?? false
          : checked
      })}
      onChange={
        responsive
          ? updateResponsiveValue
          : onChange
      }
      {...props}
    />
  );
};
